const ko = {
  pleaseEnterUsername: "사용자 이름을 입력하세요",
  cannotFriendYourself: "자기 자신에게 친구 요청을 보낼 수 없습니다.",
  friendRequestSent: "친구 요청이 전송되었습니다!",
  failedToSendRequest: "요청 전송에 실패했습니다",
  linkCopied: "링크가 클립보드에 복사되었습니다!",
  backToInvites: "초대 목록으로 돌아가기",
  sendFriendRequestByUsername: "사용자 이름으로 친구 요청 보내기",
  enterUsername: "사용자 이름 입력",
  send: "보내기",
  yourInviteQrCode: "내 초대 QR 코드",
  inviteLink: "초대 링크",
  scanQrOrUseLink: "이 QR 코드를 스캔하거나 이 링크를 사용하여 친구 요청을 보내세요",
  copyInviteLink: "초대 링크 복사",
  goToItem: "항목으로 이동",
  verificationEmailSent: "인증 이메일이 전송되었습니다! 받은 편지함을 확인하세요.",
  verificationEmailFailed: "인증 이메일 전송에 실패했습니다. 다시 시도하세요.",
  verifyYourEmail: "이메일 인증",
  verifyEmailInstructions: "계정에 액세스하려면 이메일 주소를 인증하세요. 받은 편지함에서 인증 링크를 확인하세요.",
  sending: "전송 중...",
  resendVerificationEmail: "인증 이메일 다시 보내기",
  login: "로그인",
  register: "회원가입",
  home: "홈",
  calendar: "캘린더",
  friends: "친구",
  profile: "프로필",
  logout: "로그아웃",
  loading: "로딩 중...",
  language: "언어",
  calendarSelectPlaceSuggestion: "좌표를 첨부하려면 제안 목록에서 장소를 선택하세요.",
  calendarSelectDateAndTime: "날짜와 시간을 선택하세요.",
  calendarPositiveDuration: "양수의 기간을 입력하세요.",
  calendarFutureDateRequired: "이벤트 날짜와 시간은 미래여야 합니다.",
  calendarCreateEventFailed: "이벤트 생성에 실패했습니다. 다시 시도하세요.",
  cancel: "취소",
  createNewEvent: "새 이벤트 만들기",
  week: "주",
  month: "월",
  eventTitle: "제목",
  date: "날짜",
  time: "시간",
  duration: "지속 시간",
  endsAt: "종료 시간",
  place: "장소",
  searchForPlace: "장소 검색",
  placeSearchTip: "팁: 입력을 시작하고 결과를 선택하여 좌표를 첨부하세요.",
  description: "설명",
  createEvent: "이벤트 생성",
  today: "오늘",
  previousMonth: "이전 달",
  nextMonth: "다음 달",
  previous: "이전",
  next: "다음",
  mondayShort: "월",
  tuesdayShort: "화",
  wednesdayShort: "수",
  thursdayShort: "목",
  fridayShort: "금",
  saturdayShort: "토",
  sundayShort: "일",
  more: "더보기",
  mustRespondWillBeforeReposting: "\"참석\"을 선택한 후에만 다시 공유할 수 있습니다",
  event: "이벤트",
  backToCalendar: "캘린더로 돌아가기",
  addToGoogleCalendar: "Google 캘린더에 추가",
  when: "언제",
  where: "어디",
  openLocationInGoogleMaps: "Google 지도에서 위치 열기",
  hosts: "주최자",
  yourResponse: "내 응답",
  currentResponse: "현재 응답",
  response_will: "참석",
  response_might: "참석할 수도 있음",
  response_wont: "참석하지 않음",
  willRunIntoYou: "들를게요",
  mightDropBy: "들를 수도 있어요",
  wontCome: "가지 않을게요",
  repostToMyFriends: "친구들에게 다시 공유",
  responses: "응답",
  willAttend: "참석",
  reposted: "다시 공유됨",
  mightAttend: "참석할 수도 있음",
  cancelEvent: "이벤트 취소",
  cancellationEmailNoticeBefore: "참석하겠다고 응답한 사람들에게",
  cancellationEmailNoticeAfter: "이벤트 취소 알림 이메일이 전송됩니다.",
  optionalCancellationMessage: "참석자에게 보낼 선택 메시지 (최대 1000자)",
  confirmCancelEvent: "이벤트 취소 확인",
  clear: "지우기",
  confirmCancellation: "취소 확인",
  confirmCancellationMessage: "정말로 이 이벤트를 취소하시겠습니까? 확인된 참석자에게 알림이 전송되고 이벤트가 삭제됩니다.",
  eventCancelledNotified: "이벤트가 취소되었습니다. 알림 전송 대상:",
  attendees: "참석자",
  failedToCancelEvent: "이벤트 취소에 실패했습니다",
  back: "뒤로",
  cancelled: "취소됨",
  ok: "확인",
  forgotPassword: "비밀번호 찾기",
  email: "이메일",
  passwordResetLinkSent: "계정이 존재하는 경우 비밀번호 재설정 링크가 전송되었습니다.",
  passwordResetRequestFailed: "비밀번호 재설정 요청에 실패했습니다.",
  sendResetLink: "재설정 링크 보내기",
  addFriend: "친구 추가",
  incomingRequests: "받은 요청",
  accept: "수락",
  deny: "거절",
  myFriends: "내 친구",
  noFriendsYet: "아직 친구가 없습니다. 친구를 추가해 보세요!",
  seeProfile: "프로필 보기",
  noEventsToRespondTo: "응답할 이벤트가 없습니다",
  allCaughtUp: "모두 확인했습니다. 친구들의 새 이벤트를 나중에 확인하세요.",
  events: "이벤트",
  unknown: "알 수 없음",
  noDescriptionProvided: "설명이 제공되지 않았습니다.",
  will: "참석",
  maybe: "아마도",
  wont: "불참",
  userNotFound: "사용자를 찾을 수 없습니다",
  friendRequestSentSuccessfully: "친구 요청이 성공적으로 전송되었습니다!",
  friendInvitation: "친구 초대",
  sendFriendRequest: "친구 요청 보내기",
  loginToSendFriendRequest: "친구 요청을 보내려면 로그인하세요",
  chooseLanguage: "언어 선택",
  invalidCredentials: "잘못된 로그인 정보입니다. 다시 시도하세요.",
  username: "사용자 이름",
  password: "비밀번호",
  forgotPasswordQuestion: "비밀번호를 잊으셨나요?",
  dontHaveAccount: "계정이 없으신가요?",
  registerHere: "여기에서 가입하세요",
  invalidProfilePhotoType: "잘못된 파일 형식입니다. JPEG, PNG, GIF 또는 WebP 이미지를 업로드하세요.",
  invalidFileExtension: "잘못된 파일 확장자",
  allowedExtensions: "허용됨",
  fileTooLarge: "파일이 너무 큽니다",
  maximumFileSize: "최대",
  profilePhotoRemoved: "프로필 사진이 삭제되었습니다.",
  failedToRemoveProfilePhoto: "프로필 사진 삭제에 실패했습니다",
  profileUpdatedSuccessfully: "프로필이 성공적으로 업데이트되었습니다!",
  failedToUpdateProfile: "프로필 업데이트에 실패했습니다",
  privateEmailExplanation: "플랫폼 외부의 원치 않는 연락을 방지하기 위해 이메일은 본인만 볼 수 있습니다",
  yourEmailIsPrivate: "이메일은 비공개입니다.",
  profilePhoto: "프로필 사진",
  removePhoto: "사진 삭제",
  firstName: "이름",
  lastName: "성",
  tellPeopleAboutYourself: "자신을 소개해 주세요",
  whereToContactMe: "연락 방법",
  contactInfoPlaceholder: "Instagram: myUsername\nDiscord: myDiscord",
  save: "저장",
  notSet: "설정되지 않음",
  editProfile: "프로필 수정",
  imageToCrop: "자를 이미지",
  zoom: "확대/축소",
  usePhoto: "사진 사용",
  name: "이름",
  whereToContact: "연락처",
  removeFriendship: "친구 삭제",
  confirmRemoveFriend: "친구 삭제 확인",
  confirmRemoveFriendBefore: "",
  confirmRemoveFriendAfter: "님을 친구 목록에서 삭제하시겠습니까?",
  friendRemoved: "친구가 삭제되었습니다.",
  failedToRemoveFriend: "친구 삭제에 실패했습니다.",
  confirmRemove: "삭제 확인",
  error: "오류",
  removed: "삭제됨",
  passwordsDoNotMatch: "비밀번호가 일치하지 않습니다",
  registrationFailed: "회원가입에 실패했습니다. 다시 시도하세요.",
  confirmPassword: "비밀번호 확인",
  alreadyHaveAccount: "이미 계정이 있으신가요?",
  loginHere: "여기에서 로그인",
  passwordResetSuccessfully: "비밀번호가 성공적으로 재설정되었습니다.",
  failedToResetPassword: "비밀번호 재설정에 실패했습니다.",
  resetPassword: "비밀번호 재설정",
  newPassword: "새 비밀번호",
  confirmNewPassword: "새 비밀번호 확인",
  setNewPassword: "새 비밀번호 설정",
  emailVerifiedSuccessfully: "이메일 인증이 완료되었습니다!",
  emailVerificationFailed: "인증에 실패했습니다. 링크가 잘못되었거나 만료되었을 수 있습니다.",
  verifying: "인증 중...",
  verified: "인증 완료!",
  redirectingToHome: "홈으로 이동 중...",
  verificationFailed: "인증 실패",
  goToHome: "홈으로 이동",
  about: "소개",
  aboutConceptTitle: "개념",
  aboutCreatorIntroduction: "안녕하세요. 암벽 등반가이자 Run Into Me를 만든 Crypt0입니다.",
  aboutCreatorStory: "저는 사람들과 어울리는 것을 좋아해 등반 사이에도 다른 등반가들과 자주 이야기했습니다. 그 결과 연락처가 너무 많아지고 새 친구들과의 등반 일정을 잡는 데 많은 여가 시간을 쓰게 되었습니다.",
  aboutPlanningProblem: "매번 일정을 계획하고 친구들에게 따로 연락하는 대신, 정식 초대 없이 언제 어디서 등반하는지 모두에게 동시에 알리고 싶었습니다.",
  aboutDeveloperSolution: "그러다 제가 개발자이며 직접 해결책을 만들 수 있다는 사실을 떠올렸습니다.",
  aboutWelcome: "Run Into Me에 오신 것을 환영합니다. 친구들이 부담 없이 참여할 수 있는 활동 일정을 알리는 사이트입니다.",
  aboutCallToAction: "혼자서도 할 수 있지만 함께하면 더 즐거운 활동을 계획할 때 여기에 게시해 친구들에게 알려 보세요.",
  aboutTutorialTitle: "사용 안내",
  aboutCalendarCreateEvent: "캘린더 화면에서 새 이벤트를 만들 수도 있습니다.",
  aboutEventColorsIntroduction: "이벤트 색상은 참여 상태를 나타냅니다.",
  aboutColorGold: "금색",
  aboutColorGoldDescription: "직접 주최하는 이벤트입니다.",
  aboutColorGreen: "초록색",
  aboutColorGreenDescription: "참석하는 이벤트입니다.",
  aboutColorOrange: "주황색",
  aboutColorOrangeDescription: "“아마도”라고 답했습니다.",
  aboutColorBlue: "파란색",
  aboutColorBlueDescription: "아직 답하지 않았습니다.",
  aboutColorGray: "회색",
  aboutColorGrayDescription: "초대를 거절했습니다.",
  aboutCalendarEventDetails: "이벤트를 클릭해 자세한 정보를 확인하고 응답하세요.",
  aboutFriendPageTitle: "친구 페이지",
  aboutFriendPageDescription: "사용자 이름을 입력하거나 초대 링크 / QR 코드를 보내 친구를 추가하세요.",
  aboutHomePageTitle: "홈페이지",
  aboutHomePageDescription: "친구들의 예정된 이벤트를 넘겨보며 참석 여부를 알려 주세요.",
  aboutRepostScreenTitle: "재게시 화면",
  aboutGoogleCalendarDescription: "이 버튼으로 이벤트를 Google 캘린더에 추가하세요.",
  aboutRepostDescription: "참석한다고 응답한 친구의 이벤트를 자신의 친구들에게 재게시할 수 있습니다.",
};

export default ko;